<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import { computed, useAttrs } from 'vue';
import { useAppConfig } from '#app/config';
import DButton from '#layers/ui/components/Button.vue';
import DTooltip from '#layers/ui/components/Tooltip.vue';
import { useDisabledNotice } from '#layers/ui/composables/use-disabled-notice';

defineOptions({
	name: 'ButtonAdd',
	inheritAttrs: false,
});

const props = withDefaults(
	defineProps<Partial<ButtonProps & { disabled?: boolean; disabledNotice?: string }>>(),
	{
		size: 'sm',
		variant: 'outline',
		color: 'neutral',
		// Otherwise both are set to `false` and NuxtLink will detect a conflict
		prefetch: undefined,
		noPrefetch: undefined,
	},
);

const attrs = useAttrs();
const { showDisabledNotice } = useDisabledNotice(props);
const buttonProps = computed(() => {
	const { disabledNotice: _, ...forwardedProps } = props;
	return { ...attrs, ...forwardedProps };
});
const appConfig = useAppConfig();
</script>

<template>
	<DTooltip :delay-duration="0" :disabled="!showDisabledNotice" :text="disabledNotice">
		<DButton
			v-bind="buttonProps"
			:icon="appConfig.ui.icons.plus"
		>
			<slot />
		</DButton>
	</DTooltip>
</template>
